module.exports = __webpack_public_path__ + "img/order-single-img.0a42f57d.svg";